import ProductInquiryFormLink from "./product-inquiry-link";

export default class ProductAvailabilityTable{
    private baseElement: HTMLElement;

    constructor(baseElement: HTMLElement){
        this.baseElement = baseElement;
    }

    // The component HTML now arrives via the page-level batched request (common.loadAsyncComponents);
    // this runs the same post-load wiring the old per-component load() did.
    initLoaded(loadedElement: HTMLElement): void {
        if (!loadedElement) {
            return;
        }
        this.baseElement = loadedElement;
        const linkElement = this.baseElement.querySelector('[data-component-part="contact-us-link"]') as HTMLAnchorElement;
        linkElement && new ProductInquiryFormLink(linkElement).init();
    }
}
